export const UserRole = {
    NewFcaReadOnly: 'NewFcaReadOnly',
    NewFcaSettlementTeam: 'NewFcaSettlementTeam',
    NewFcaAnalysisTeam: 'NewFcaAnalysisTeam',
    NewFcaManagementTeam: 'NewFcaManagementTeam',
    NewFcaAdmin: 'NewFcaAdmin'
}